import { render, staticRenderFns } from "./user-balance.vue?vue&type=template&id=17c814b0&scoped=true"
import script from "./user-balance.vue?vue&type=script&lang=js"
export * from "./user-balance.vue?vue&type=script&lang=js"
import style0 from "./user-balance.vue?vue&type=style&index=0&id=17c814b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c814b0",
  null
  
)

export default component.exports